import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetWorkHistoryLayerListRequest,
	IPayloadGetWorkHistoryLayerListSuccess,
	IWorkHistoryLayerDetailStore,
} from './work-history-layer.type';

const initialState = {
	fetching: false,
	workHistoryLayerList: [] as IWorkHistoryLayerDetailStore[],
};

const workHistoryLayerSlice = createSlice({
	initialState,
	name: 'workHistoryLayer',
	reducers: {
		/**---- GET WORK_HISTORY_LAYER LIST START ---- */
		getWorkHistoryLayerListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkHistoryLayerListRequest>
		) => {
			state.fetching = true;
		},
		getWorkHistoryLayerListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkHistoryLayerListSuccess>
		) => {
			const { content } = action.payload;
			state.fetching = false;
			state.workHistoryLayerList = content;
		},
		getWorkHistoryLayerListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET WORK_HISTORY_LAYER LIST END ---- */
	},
});

export const WorkHistoryLayerSelectors = {
	selectFetching: (state: RootState) => state.workHistoryLayer.fetching,
	selectList: (state: RootState) => state.workHistoryLayer.workHistoryLayerList,
};

export const WorkHistoryLayerActions = workHistoryLayerSlice.actions;
export const WorkHistoryLayerReducer = workHistoryLayerSlice.reducer;
